export function calculateLTV(mortgage, price) {
    return mortgage / price;
}
